import { Injectable, signal } from '@angular/core';
import { UserModel } from '@app/models/user';

@Injectable({
  providedIn: 'root',
})
export class User {
  private user = signal<UserModel | null>(null);

  getCookie(name: string): string | null {
    const match = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]+)')
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  setUserFromCookie() {
    const tokena = this.getCookie('access_token');
    const userInfo = tokena
      ? JSON.parse(atob(tokena.split('.')[1]))?.user
      : null;
    const { roles } = userInfo || {};
    this.setUser({
      name: userInfo?.name || '',
      email: userInfo?.email || '',
      roles: Array.isArray(roles) ? roles : [],
    });
    return userInfo;
  }

  getUser(): UserModel | null {
    return this.user();
  }

  setUser(userInfo: UserModel | null) {
    this.user.set(userInfo);
  }

  hasRole(role: string): boolean {
    const user = this.getUser();
    return user ? user.roles.includes(role) : false;
  }
}
